import { Simplify } from '../../../../prismicio-types';
import { Content } from '@prismicio/client';
import styles from './Card.module.scss';
import { PrismicNextImage } from '@prismicio/next';

interface Props {
  data: Simplify<Content.StatsCardSliceDefaultPrimaryCardsItem>;
}

const Card = ({ data }: Props) => {
  return (
    <article className={styles.card}>
      <p className={styles.title}>{data.title}</p>
      <div className={styles.valueWrapper}>
        <PrismicNextImage field={data.icon} className={styles.icon} />
        <p className={styles.value}>{data.value}</p>
      </div>
    </article>
  );
};

export default Card;
